import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class DeliveryMonthReferenceService extends BaseReferenceService {
  constructor() {
    super('DeliveryMonthReference');
  }
}
